import { MobileHead, TextField, IconWithText, MobileList, MobileTopButton, Loader } from 'Components/index';
import PropTypes from 'prop-types';
import React from 'react';
import i18n from 'i18next';
import './LoginAsAdminMobile.css';

const LoginAsAdminMobile = (props) => {
  const [selectedUser, setSelectedUser] = React.useState(undefined);

  const data = props.data.map(item => item.UserName);

  if (selectedUser !== undefined) {
    return (
      <div>
        <MobileTopButton
          icon="chevron_left"
          text={i18n.t('loginAsAdmin:LoginAs Admin')}
          onClick={() => {
            setSelectedUser(undefined);
          }}
        />
        <div className="login-as-admin-mobile__selected-user">
          <span className="login-as-admin-mobile__selected-user__name">{selectedUser.UserName}</span>
          <div>
            <span className="login-as-admin-mobile__selected-user__title">{i18n.t('loginAsAdmin:Email')}</span>
            <span className="login-as-admin-mobile__selected-user__detail">{selectedUser.EmailId}</span>
          </div>
          <div>
            <span className="login-as-admin-mobile__selected-user__title">{i18n.t('loginAsAdmin:Phone Number Number')}</span>
            <span className="login-as-admin-mobile__selected-user__detail">{selectedUser.Phone}</span>
          </div>
          <div>
            <span className="login-as-admin-mobile__selected-user__title">{i18n.t('loginAsAdmin:Password Expiry Date')}</span>
            <span className="login-as-admin-mobile__selected-user__detail">{selectedUser.PasswordExpiryDate}</span>
          </div>
        </div>
        <IconWithText
          text={i18n.t('loginAsAdmin:LoginAs')}
          textOrientation="before"
          icon="chevron_right"
          onClick={() => {
            props.handleLoginAsAdmin(selectedUser.UserCode);
          }}
          squareButton
          isFullWidth
          inverseColour
        />
      </div>
    );
  }

  return (
    <div>
      <MobileHead title={i18n.t('loginAsAdmin:LoginAs Admin')} />
      <TextField
        className="login-as-admin__mobile__search-field"
        title={i18n.t('loginAsAdmin:Enter Criteria (Name, UserName or ID)')}
        placeholder={i18n.t('loginAsAdmin:Search Users')}
        value={props.search}
        onChange={props.handleSearchChange}
        icon="search"
      />
      {props.isLoading ?
        <div className="login-as-admin-mobile__loader">
          <Loader isSolidWhite isSmall />
        </div> :
        <MobileList
          data={data}
          icon="chevron_right"
          onClick={(e, i) => {
          setSelectedUser(props.data[i]);
        }}
        />
      }
    </div>
  );
};

LoginAsAdminMobile.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
  handleLoginAsAdmin: PropTypes.func,
  search: PropTypes.string,
  handleSearchChange: PropTypes.func,
  isLoading: PropTypes.bool,
};


export default LoginAsAdminMobile;



// WEBPACK FOOTER //
// ./src/containers/LoginAsAdmin/LoginAsAdminMobile/LoginAsAdminMobile.jsx